module.exports = __webpack_public_path__ + "images/help/video-kanban@2x-8d0c378ea471f6fea8f8da1c98cc0deb.png";